import { ValidationErrors } from 'final-form';

export default function (formValues, labels, validations): ValidationErrors {
  const errors: { [prop: string]: unknown } = {};
  return validations(formValues, errors, labels);
}
